import AppException from './AppException'
class SharedImageThumbnailer {
  constructor () {
    this.isCompressing = false
    this.compressObservers = []

    this.defaultOpt = {
      orientation: true,
      maxWidth: 1920,
      maxHeight: 1080,
      format: 'image/jpeg'
    }
  }

  requestCompress (file, cb, opt) {
    this.compressObservers.push({ cb, file, opt })
    if (!this.isCompressing) {
      this.startCompress4()
    }
  }

  cancelCompressRequest (cb) {
    let idx = this.compressObservers.findIndex(o => o.cb === cb)
    if (idx === 0) console.warn('刪除idx=0...可能造成異常')
    if (idx >= 0) this.compressObservers.splice(idx, 1)
  }

  async startCompress4 () {
    this.isCompressing = true
    for (;;) {
      try {
        let target = this.compressObservers[0]

        var opt = Object.assign({}, this.defaultOpt)
        opt = Object.assign(opt, target.opt)

        window.loadImage(
          target.file,
          img => {
            if (img.type === 'error') {
              throw new AppException('compress failed')
            } else {
              img.toBlob(
                (blob) => {
                  target.cb(blob)
                },
                opt.format
              )
            }
          },
          opt
        )
      } catch (err) {
        console.error(err)
      }
      this.compressObservers.splice(0, 1)

      if (this.compressObservers.length === 0) break
    }
    this.isCompressing = false
  }
}

const ImageThumbnailer = {
  shared: new SharedImageThumbnailer()
}
export default ImageThumbnailer
